import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ApexFill, ChartComponent } from 'ng-apexcharts';
import { Subscription } from 'rxjs';
// import { TouchSequence } from 'selenium-webdriver';
import { ChartOptions } from '@huge-monorepo/hip/domain';
import { GraphChange } from '@huge-monorepo/hip/domain';
import { SideNavToggleService } from '@huge-monorepo/hip/services';
import { TableHeader } from '@huge-monorepo/hip/domain';
import { TableComponent } from '../table/table.component';
import { ToolsService } from '@huge-monorepo/hip/services';

type axisChartNamed = { name?: string; type?: string; color?: string; group?: string; data: number[] };

// Might want this in future for typing...
// type axischart =
//   | axisChartNamed
//   | { x: any; y: any; fill?: ApexFill; fillColor?: string; strokeColor?: string; meta?: any; goals?: any; barHeightOffset?: number; columnWidthOffset?: number }[]
//   | number[][];

@Component({
  selector: 'app-generic-graph',
  templateUrl: './generic-graph.component.html',
  styleUrls: ['./generic-graph.component.scss'],
})
export class GenericGraphComponent implements OnInit, AfterViewInit {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  @ViewChild('tableView', { static: false }) public tableView: TableComponent;
  public chartOptions: Partial<ChartOptions>;
  loading: boolean = false;
  graphLoaded: boolean = true;
  @Input() height: any;
  sidenavObservable: Subscription;
  @Input() enableDataLabels: boolean = true;
  @Input() showToolbar: boolean = true;
  @Output() selected: EventEmitter<number> = new EventEmitter<number>();
  @Input() enableDataPoints: boolean = false;
  @Input() isTableView: boolean = false;
  tableViewHeaders: TableHeader[];
  tableViewData: any[];

  constructor(private detector: ChangeDetectorRef, private navigationService: SideNavToggleService, private tools: ToolsService) { }
  ngAfterViewInit(): void {
    // let graphDisplay = document.getElementsByClassName('graph-display');
  }

  ngOnInit() {
    this.tableViewHeaders = [
      {
        ID: 'Time',
        Index: 0,
        Sort: 'Time',
        Sortable: false,
        Text: 'Time',
        Type: String,
        Align: 'left',
      },
    ];

    this.tableViewData = [];

    this.chartOptions = {
      series: [],
      chart: {
        type: 'line',
        events: {
          mounted: (chart) => {
            chart.windowResizeHandler();
          },
          dataPointSelection: (event, chartContext, config) => {
            this.notifySelected(config.dataPointIndex);
            // this.selected.emit(config.dataPointIndex);
          },
        },
        height: this.height ?? 'auto',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: this.showToolbar,
        },
        animations: {
          enabled: false,
        },
      },
      fill: {
        colors: ['#77B6EA', '#F78cua'],
        type: 'solid',
        opacity: 0.5,
      },
      colors: ['#FFBE0B', '#FB5607', '#FF006E', '#8338EC', '#3A86FF', '#03045E', '#023E8A', '#FF9E00', '#fc2f00', '#00ffe7'],
      stroke: {
        curve: 'straight',
        width: 4,
      },
      dataLabels: {
        enabled: this.enableDataLabels,
        offsetY: -20,
        style: {
          // fontSize: "12px",
          colors: ['#000000'],
        },
      },
      title: {
        text: '',
        align: 'center',
      },
      markers: {
        size: this.enableDataPoints ? 1 : 0,
        hover: {
          sizeOffset: 4,
        },
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        categories: [],
        title: {
          text: '',
        },
        labels: {
          formatter: (value: any) => {
            let d = new Date(value);
            this.tools.FormatDateTimeFromDateSwedish(d);

            return this.tools.FormatDateTimeFromDateSwedish(d);
          },
        },
      },
      yaxis: {
        title: {
          text: '',
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -10,
        offsetX: -5,
        show: true,
      },
    };

    this.sidenavObservable = this.navigationService.GetSideNav((data) => {
      if (this.loading != true) {
        let temp = this.loading;
        this.loading = true;
        setTimeout(() => {
          this.loading = temp;
        });
      }
    });
  }

  public setGraphData(c: GraphChange) {
    this.loading = true;
    this.detector.detectChanges();
    if (c.chart) {
      this.chartOptions.chart.dropShadow = c.chart.dropShadow ?? this.chartOptions.chart.dropShadow;
    }
    this.chartOptions.legend.floating = c.floating ?? true;
    this.chartOptions.series = c.Data.SeriesData;
    this.chartOptions.title.text = c.Data.GraphTitle;
    this.chartOptions.chart.type = c.Data.GraphType;
    this.chartOptions.xaxis.labels.offsetY = c.Data.XAxisLabelOffsetY ?? 0;
    this.chartOptions.xaxis.title.text = c.Data.XAxisLabel;
    this.chartOptions.yaxis.title.text = c.Data.YAxisLabel;
    this.chartOptions.xaxis.categories = c.Data.XAxisCategories;
    this.chartOptions.legend.customLegendItems = c.Data.customLegendItems ?? [];
    this.chartOptions.legend.show = true;
    this.chartOptions.xaxis.type = c.xAxisType ?? 'category';
    if (c.Data.Stacked != null) {
      this.chartOptions.chart.stacked = c.Data.Stacked;
    }

    if (c.Data.DataLabels != null) {
      this.chartOptions.dataLabels = c.Data.DataLabels;
    }

    if (c.Data.PlotOptions != null) {
      this.chartOptions.plotOptions = c.Data.PlotOptions;
    }

    if (c.TickAmount) {
      this.chartOptions.xaxis.tickAmount = c.TickAmount;
    }

    if (this.chartOptions.xaxis.type == 'category') {
      this.chartOptions.xaxis.labels = {};
    }
    this.chartOptions.colors = c.colors;
    this.chartOptions.fill.colors = c.colors;

    this.tableViewHeaders = [
      {
        ID: 'Time',
        Index: 0,
        Sort: 'Time',
        Sortable: false,
        Text: 'Time',
        Type: String,
        Align: 'left',
      },
    ];

    this.tableViewData = [];

    for (let i = 0; i < this.chartOptions.series.length; i++) {
      this.tableViewHeaders.push({
        ID: (this.chartOptions.series[i] as axisChartNamed).name,
        Index: 0,
        Sort: (this.chartOptions.series[i] as axisChartNamed).name,
        Sortable: false,
        Text: (this.chartOptions.series[i] as axisChartNamed).name,
        Type: Number,
        Align: 'left',
      });
    }

    for (let j = 0; j < this.chartOptions.xaxis.categories.length; j++) {
      let newDataObj = {
        Time: this.chartOptions.xaxis.categories[j],
      };

      for (let k = 0; k < this.chartOptions.series.length; k++) {
        newDataObj[(this.chartOptions.series[k] as axisChartNamed).name] = (this.chartOptions.series[k] as axisChartNamed).data[j];
      }
      this.tableViewData.push(newDataObj);
    }

    if (c.Data.LegendPosition != null) {
      this.chartOptions.legend.position = c.Data.LegendPosition;
    }
    this.loading = false;

    if (this.detector != null && !(this.detector as ViewRef).destroyed) {
      this.detector.detectChanges();
    }
  }

  public setGraphLoading() {
    this.loading = true;
  }

  notifySelected(dataPointIndex) {
    if (this.selected != null) {
      this.selected.emit(dataPointIndex);
    }
  }
}
